import { ACTIONS, FieldActions, TInputField, ResetFieldAction, TAcquisitionState, UpdateFieldAction, BulkUpdateFieldAction } from "./types";

const createInputField = (): TInputField => ({ value: '', state: 'neutral', errorType: 'None' });
export const initialAcquisitionState: TAcquisitionState = {
    authorizedUserFirstName: createInputField(),
    authorizedUserLastName: createInputField(),
    authorizedUserMiddleInitial: createInputField(),
    firstName: createInputField(),
    lastName: createInputField(),
    middleInitial: createInputField(),
    suffix: createInputField(),
    emailAddress: createInputField(),
    phoneNumber: createInputField(),
}

export const acquisitionReducer = (acquisitionState: TAcquisitionState, action: FieldActions): TAcquisitionState => {
    switch (action.type) {
        case ACTIONS.UPDATE_FIELD: {
            const { field, value, state, errorType } = (action as UpdateFieldAction).payload;
            const stateField = acquisitionState[field];
            const isValueUpdate = stateField?.value !== value;
            const isStateUpdate = stateField?.state !== state;
            const isErrorTypeUpdate = stateField?.errorType !== errorType;

            if (isValueUpdate || isStateUpdate || isErrorTypeUpdate) {
                /**
                 * !!Important!!
                 * This function uses a shallow copy of the original state to ensure that subscribed
                 * listeners are invoked. It is up to each listener to determine if the field refs
                 * between the previous field and the incoming field are actually different.
                 */
                return {
                    ...acquisitionState,
                    [field]: {
                        ...acquisitionState[field],
                        ...isValueUpdate ? { value: value } : {},
                        ...isStateUpdate ? { state: state } : {},
                        ...isErrorTypeUpdate ? { errorType: errorType } : {},
                    }
                };
            }
            return acquisitionState;
        };

        case ACTIONS.BULK_UPDATE_FIELD: {
            const targetUpdates = (action as BulkUpdateFieldAction).payload;
            /**
             * !!Important!!
             * This function uses a shallow copy of the original state to ensure that subscribed
             * listeners are invoked. It is up to each listener to determine if the field refs
             * between the previous field and the incoming field are actually different.
             */
            const { updated, hasUpdates } = Object.keys(targetUpdates).reduce((acc, key) => {
                const isValueUpdate = Object.prototype.hasOwnProperty.call(targetUpdates[key], 'value') && targetUpdates[key].value !== acquisitionState[key].value;
                const isStateUpdate = Object.prototype.hasOwnProperty.call(targetUpdates[key], 'state') && targetUpdates[key].state !== acquisitionState[key].state;
                const isErrorTypeUpdate = Object.prototype.hasOwnProperty.call(targetUpdates[key], 'errorType') && targetUpdates[key].errorType !== acquisitionState[key].errorType;

                if (isValueUpdate || isStateUpdate || isErrorTypeUpdate) {
                    acc.hasUpdates = true;
                    acc.updated[key] = {
                        ...acquisitionState[key],
                        ...isValueUpdate ? { value: targetUpdates[key].value } : {},
                        ...isStateUpdate ? { state: targetUpdates[key].state } : {},
                        ...isErrorTypeUpdate ? { errorType: targetUpdates[key].errorType } : {},
                    }
                }

                return acc;
            }, { updated: { ...acquisitionState }, hasUpdates: false });

            return hasUpdates ? updated : acquisitionState;
        };

        case ACTIONS.RESET_FIELD: {
            const { field } = (action as ResetFieldAction).payload;
            const stateField = acquisitionState[field];

            if (!stateField) {
                return acquisitionState;
            }

            const immutableCopy = JSON.parse(JSON.stringify(acquisitionState));
            immutableCopy[field] = createInputField();
            return immutableCopy;
        }

        default:
            return acquisitionState;
    }
}